import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { styled } from "../../theme";
export const Input = forwardRef(({ ...props }, ref) => _jsx(BaseInput, { ...props, ref: ref }));
export const BaseInput = forwardRef(({ testId, 
/**
 * HACK: we don't render name in HTML so we disable the autocomplete.
 */
name, ...props }, ref) => (_jsx(TextInput, { ...props, ref: ref, maxLength: props.maxLength, "data-test-id": testId ?? name, onChange: props.disabled ? undefined : props.onChange })));
export const TextArea = forwardRef((props, ref) => _jsx(TextAreaInput, { ...props, ref: ref }));
const TextInput = styled.input `
  font-size: 1.375em;
  padding: 0.75em 4px;
  border: none;
  width: 100%;
  min-width: 1px;
  font-family: Gilroy, sans-serif;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.color.darkBlue90};
  background: transparent;
  box-shadow: none; // Firefox: Remove default red shadow on invalid input (e.g. email)

  ::placeholder {
    color: ${({ theme }) => theme.color.darkBlue90};
    opacity: 0.75;
  }

  ::-webkit-calendar-picker-indicator {
    display: none;
  }

  &:focus {
    outline: none;
    ::placeholder {
      color: ${({ theme }) => theme.color.darkBlue90};
    }
  }

  &[disabled] {
    opacity: 0.65;
    cursor: not-allowed;
    filter: saturate(25%);
  }
`;
const TextAreaInput = styled.textarea `
  font-size: 1.2em;
  padding: 0.75em 4px;
  border: none;
  width: 100%;
  min-width: 1px;
  font-family: Gilroy, sans-serif;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.color.darkBlue90};
  background: transparent;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    font-size: 1.375em;
  }

  ::placeholder {
    color: ${({ theme }) => theme.color.darkBlue90};
    opacity: 0.75;
  }

  &:focus {
    outline: none;
    ::placeholder {
      color: ${({ theme }) => theme.color.darkBlue90};
    }
  }

  &[disabled] {
    opacity: 0.65;
    cursor: not-allowed;
    filter: saturate(25%);
  }
`;
